// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__71mBq","listItem":"styles_listItem__boXlZ"};